import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-cap-3-icon',
  templateUrl: './design-cap-3.component.html'
})
export class DesignCap3Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
